import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

const PATH = '/biis/catalogos';

@Component({
  selector: 'app-catalogs',
  templateUrl: './catalogs.component.html',
  styleUrls: ['../../../app.component.scss']
})
export class CatalogsComponent implements OnInit {
  public url: string = environment.clientUrl + PATH + '?us=';
  public urlSafe: SafeResourceUrl;

  constructor(
    private cookieService: CookieService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const petition = this.cookieService.get('auth');
    const us = JSON.parse(petition);
    us.path = PATH;

    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url + JSON.stringify(us));
  }

}
